import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotion-post-grid',
  templateUrl: './promotion-post-grid.component.html',
  styleUrls: ['./promotion-post-grid.component.css']
})
export class PromotionPostGridComponent implements OnInit {

  title ="View Promotion Post";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Promotions/promotions-post/promotion-post-grid/promotion-post-grid.component.ts